import "./starting.css";
import "../../fonts/fonts.css";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import RoutesToPages from "../../RoutesToPages";

const StartingPage = () => {
  const myRef = useRef(null);
  const navigate = useNavigate();

  const redirectToPreferences = () => {
    navigate(RoutesToPages.preferences);
  };

  return (
    <section>
      <div ref={myRef} className="starting__page_wrapper">
        <div className="starting__page">
          <div className="starting__logo_wrapper">
            <img
              className="starting__logo"
              src={require("./img/start.png")}
              alt="starting__logo"
            />
          </div>
          <div id="starting__text" className="starting__page_text">
            Ugotujmy coś wyjątkowego! Odpowiedz na kilka pytań, a ja wygeneruję dla Ciebie przepis.
          </div>
          <button
            className="starting__page_button"
            onClick={redirectToPreferences}
          >
            Start
          </button>
        </div>
        <a className="account-link" onClick={() => navigate(RoutesToPages.myAccount)}>
          Anuluj subskrypcję
        </a>
      </div>
    </section>
  );
};

export default StartingPage;
